import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useScnEventsStore } from 'src/store/benefits/scn-events.store';

export default function useScnEventsList() {
  const navigate = useNavigate();

  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'startDate', label: 'Data de Início', type: 'dateOnly' },
    { id: 'endDate', label: 'Data de Fim', type: 'dateOnly' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  const { loadingScnEventsList, scnEventsList, getScnEventsList } = useScnEventsStore();

  useEffect(() => {
    getScnEventsList();
  }, []);

  return {
    TABLEHEADER,
    loadingScnEventsList,
    scnEventsList,
    navigate,
  };
}
